import { parse } from 'graphql'

/**
 * List orders from the IT Management Marketplace cell service.
 * All orders live on the cell; no backup in the main backend.
 */
export const LIST_ORDERS = parse(`
  query ListOrders($companyId: Int!) {
    orders(companyId: $companyId) {
      id
      displayId
      status
      currency
      price
      cartId
      createdAt
      itemsCount
    }
  }
`)

/**
 * PlaceOrders mutation for the IT Management Marketplace cell service.
 * Sends the cart to the cell to create orders (no federation; request goes to cell URL).
 */
export const PLACE_ORDERS = parse(`
  mutation PlaceOrders(
    $cartId: String!
    $companyId: Int!
    $companyName: String!
    $companyVat: String!
    $currency: String!
    $customerEmail: String!
    $customerName: String!
    $deliveryAddress: String!
  ) {
    placeOrders(
      cartId: $cartId
      companyId: $companyId
      companyName: $companyName
      companyVat: $companyVat
      currency: $currency
      customerEmail: $customerEmail
      customerName: $customerName
      deliveryAddress: $deliveryAddress
    ) {
      id
      displayId
      status
      currency
      price
      cartId
    }
  }
`)
